import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { IMAGES } from "@/data/classes";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-md p-3 inline-block border border-gray-200">
          <img src={IMAGES.logo} alt="Rhythm Check Training" className="h-10 w-auto" />
        </div>
        <div className="font-mono-label text-[#d90429] mt-8 mb-3">Admin Access</div>
        <h1 className="font-display text-4xl font-black text-[#0a0a0a]">Sign in.</h1>
        <p className="mt-3 text-gray-600">Manage class availability and view registrations.</p>

        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="admin-login-form">
          <div>
            <label className="font-mono-label block mb-2">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="admin-login-email"
              className="w-full border border-gray-300 rounded-md px-4 py-3 focus:outline-none focus:border-[#d90429] focus:ring-2 focus:ring-[#d90429]/20"
            />
          </div>
          <div>
            <label className="font-mono-label block mb-2">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-login-password"
              className="w-full border border-gray-300 rounded-md px-4 py-3 focus:outline-none focus:border-[#d90429] focus:ring-2 focus:ring-[#d90429]/20"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full inline-flex justify-center items-center gap-2 rounded-md bg-[#d90429] px-8 py-4 text-base font-bold text-white hover:bg-black transition-colors disabled:opacity-60"
          >
            <Lock className="w-4 h-4" />
            {loading ? "Signing in…" : "Sign In"}
            <ArrowRight className="w-4 h-4" />
          </button>
        </form>
      </div>
    </div>
  );
}
